module.exports = __webpack_public_path__ + "static/media/source-contract.2e7e96a8.svg";